import { connect } from "react-redux";

import SalesforceSandboxConfigurationView from "./SalesforceSandboxConfigurationView.jsx";
import {
  getIntegrationForType,
  fetchOpportunityFields,
  fetchCustomFields,
  deleteCustomFields,
  saveOpportunityFields,
  syncOpportunityFields,
} from "src/legacy/redux/actions/integrations.jsx";
import {
  updateConfiguration, authenticateAccount, deactivateSalesforceIntegration, changePrimaryConfiguration, updatePrimaryEventsOverride,
  fetchSalesforceIntegration, authenticateSecondaryAccount
} from "src/legacy/redux/actions/integrations/salesforceSandbox.jsx";
import { deactivateIntegration, deactivateV2Integration } from 'src/legacy/redux/actions/integrations.jsx';
import _ from "lodash";

const mapStateToProps = (state, ownProps) => {

  const isSecondaryExpired = _.get(state,"legacyRootReducer.settings.integrations.salesforceSandbox.primaryInstanceOverride.configuration.state.code") === "auth_error" ? true : false

  return {
    authenticating: state.legacyRootReducer.settings.integrations.salesforceSandbox.authentication.authenticating,
    errors: state.legacyRootReducer.settings.integrations.salesforceSandbox.changes.error,
    updating: state.legacyRootReducer.settings.integrations.salesforceSandbox.changes.saving,
    loading: state.legacyRootReducer.settings.integrations.salesforceSandbox.changes.loading,
    user: state.users.me,
    opportunityFields: state.legacyRootReducer.settings.integrations.activated.opportunityFields.items,
    customFields: state.legacyRootReducer.settings.integrations.activated.customFields.items,
    loadingFields: state.legacyRootReducer.settings.integrations.activated.opportunityFields.loading,
    deleting: state.legacyRootReducer.settings.integrations.salesforceSandbox.deletion.removing,
    updatingPrimaryConfig: _.get(state, "legacyRootReducer.settings.integrations.activated.updatingPrimaryConfig.updating", false),
    primaryInstanceOverride: _.get(state, "legacyRootReducer.settings.integrations.salesforceSandbox.primaryInstanceOverride"),
    updatingPrimaryOverrideEvents: _.get(state, "legacyRootReducer.settings.integrations.salesforceSandbox.updatingPrimaryOverrideEvents.updating",false),
    isSecondaryExpired,
    adminConfiguration: _.get(state,"legacyRootReducer.settings.integrations.salesforceSandbox.primaryIntegration",{})
    
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateConfiguration: (configuration) => {
      return dispatch(updateConfiguration(configuration));
    },
    fetchOpportunityFields: (id, filters) => {
      return dispatch(fetchOpportunityFields(id, filters));
    },
    fetchCustomFields: (id) => {
      return dispatch(fetchCustomFields(id));
    },
    saveOpportunityFields: (id, fields) => {
      return dispatch(saveOpportunityFields(id, fields));
    },
    syncOpportunityFields: (id) => {
      return dispatch(syncOpportunityFields(id));
    },
    deleteCustomFields: (id, customFieldIds) => {
      return dispatch(deleteCustomFields(id, customFieldIds));
    },
    deactivateSalesforceIntegration: (type) =>{
      return dispatch(deactivateSalesforceIntegration(type));
    },
    authenticateAccount: (code) => {
      return dispatch(authenticateAccount(code));
    },
    deactivateIntegration: (type) => {
      return dispatch(deactivateIntegration(type));
    },
    deactivateV2Integration: (type) => {
      return dispatch(deactivateV2Integration(type));
    },
    changePrimaryConfiguration: (id, code) => {
      return dispatch(changePrimaryConfiguration(id, code));
    },
    updatePrimaryEventsOverride: (configuration) => {
      return dispatch(updatePrimaryEventsOverride(configuration));
    },
    fetchSalesforceIntegration: () => {
      return dispatch(fetchSalesforceIntegration());
    },
    authenticateSecondaryAccount: (code, id) => {
      return dispatch(authenticateSecondaryAccount(code,id))
    }
  };
};

const SalesforceSandboxConfigurationPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesforceSandboxConfigurationView);

export default SalesforceSandboxConfigurationPage;